<template>
  <transition enter-active-class="tw-transition-opacity tw-duration-300 tw-ease-in"
              enter-class="tw-opacity-0"
              leave-active-class="tw-transition-opacity tw-duration-300 tw-ease-out"
              leave-to-class="tw-opacity-0">
    <div v-show="loading" class="tw-w-full tw-h-full tw-absolute tw--inset-0 tw-bg-white tw-bg-opacity-75">
      <div class="tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center">
        <div class="tw-flex tw-items-center">
          <img :src="require('../../images/ball.png').default" alt="" class="tw-w-16 tw-animate-spin">
          <p class="tw-font-bold tw-text-blue">Chargement&hellip;</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
